import { AdvancedFilters, type AdvancedFiltersProps } from 'components/Blotters/Filter/AdvancedFilters';
import { connect } from 'react-redux';
import { quoteBlotterFilterChanged } from 'state/blotters/quote';
import { getQuoteBlotterFilters } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export const mapStateToProps = (
  state: AppState,
): Pick<AdvancedFiltersProps, 'currencyFilter' | 'startDate' | 'endDate'> => {
  const { startDate, endDate, currencyFilter } = getQuoteBlotterFilters(state);
  return {
    startDate,
    endDate,
    currencyFilter,
  };
};

export const mapDispatchToProps = (
  dispatch: ThunkDispatch,
): Pick<AdvancedFiltersProps, 'onCurrencyFilterChanged' | 'onStartDateFilterChanged' | 'onEndDateFilterChanged'> => ({
  onCurrencyFilterChanged(value) {
    dispatch(quoteBlotterFilterChanged('currencyFilter', value));
  },
  onStartDateFilterChanged(date) {
    if (date) {
      dispatch(quoteBlotterFilterChanged('startDate', date));
    }
  },
  onEndDateFilterChanged(date) {
    if (date) {
      dispatch(quoteBlotterFilterChanged('endDate', date));
    }
  },
});

export const ConnectedQuotesAdvancedFilters = connect(mapStateToProps, mapDispatchToProps)(AdvancedFilters);
